// Outer
import React from 'react';
import { Grid, Typography, Box, Paper } from '@mui/material';

// Inner
import HeaderBar from '@/common/layouts/HeaderBar';
import DefaultLayout from '@/common/layouts/DefaultLayout';
import Division from '@/common/components/Division';
import { getServerSidePropsPrefetch } from '@/common/utils/ssr';
import { ssrMenuItems } from '@/common/hooks/useMenuItems';
import HeroBanner from '@/common/components/HeroBanner';
import Footer from '@/common/layouts/Footer';
import { useGlobalContext } from '@/common/contexts/GlobalContext';
import { useSanitizeHtml } from '@/common/hooks/useSanitizeHtml';

export default function Page() {
  const { aboutUs } = useGlobalContext()
  return (
    <>
      <HeaderBar />
      <DefaultLayout>
        <Grid container direction="column">
          <HeroBanner />

          <Box display="flex" alignItems="center" marginBottom={2}>
            <Typography variant="h6">About Us</Typography>
          </Box>

          <Paper>
            <Box
              display="flex"
              flexDirection="row"
              flexWrap="wrap"
              justifyContent="space-evenly"
              padding={1}
            >

              <Box display="flex" alignItems="center" marginBottom={2}>
                <div
                  // add HTML sanitizing
                  dangerouslySetInnerHTML={{ __html: useSanitizeHtml(aboutUs) }}
                />
              </Box>


            </Box>
          </Paper>


          <Division />
        </Grid>
      </DefaultLayout>
      <Footer />
    </>
  );
}

export const getServerSideProps = getServerSidePropsPrefetch([
  ssrMenuItems,
]);
